// Implements: F-UIX-007, F-UIX-017
/**
 * Escape closes the TOPMOST layer only (verifier finding m1).
 *
 * Every modal or floating layer (Dialog, Drawer, ConfirmDialog, Popover, Menu) pushes its close
 * handler here while it is open; one document listener calls the last one pushed and claims the key
 * (`preventDefault`). A menu opened inside a dialog is pushed after it, so the first Escape closes
 * the menu and the second the dialog. A widget that consumes Escape itself before it reaches the
 * document (an open Combobox) calls `preventDefault`, and the stack then does nothing.
 */

type EscapeHandler = () => void;

const layers: EscapeHandler[] = [];

function onKeyDown(event: KeyboardEvent): void {
  if (event.key !== "Escape" || event.defaultPrevented) return;
  const top = layers[layers.length - 1];
  if (top === undefined) return;
  event.preventDefault();
  top();
}

/** Registers a layer's Escape handler; the returned function removes it. */
export function pushEscapeLayer(handler: EscapeHandler): () => void {
  if (layers.length === 0) document.addEventListener("keydown", onKeyDown);
  layers.push(handler);
  return () => {
    const index = layers.lastIndexOf(handler);
    if (index !== -1) layers.splice(index, 1);
    if (layers.length === 0) document.removeEventListener("keydown", onKeyDown);
  };
}
